var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _vm.showGrid
        ? _c(
            "div",
            {
              staticClass: "main-content",
              staticStyle: {
                "flex-grow": "1",
                display: "flex",
                "flex-direction": "column"
              }
            },
            [
              _vm.insuranceType === 1
                ? _c(
                    "search-item",
                    {
                      attrs: {
                        "config-module": "1101",
                        "show-more-scheme": true,
                        "show-simple": false,
                        "expand-adv": true,
                        "search-item-code": _vm.$t(
                          "Insurance.PolicyManagement"
                        ),
                        "custom-sim-query-placeholder": _vm.$t(
                          "Insurance.QuickSearchPolicyNumber"
                        )
                      },
                      on: { advSearchItemCallBack: _vm.fetchData },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "searchAreaHeader",
                            fn: function() {
                              return undefined
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3357050351
                      )
                    },
                    [
                      _c(
                        "template",
                        { slot: "operations" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.deletePolicy }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm.insuranceType === 2
                ? _c(
                    "search-item",
                    {
                      attrs: {
                        "config-module": "1102",
                        "show-more-scheme": true,
                        "show-simple": false,
                        "expand-adv": true,
                        "search-item-code": _vm.$t(
                          "Insurance.PolicyManagement"
                        ),
                        "custom-sim-query-placeholder": _vm.$t(
                          "Insurance.QuickSearchPolicyNumber"
                        )
                      },
                      on: { advSearchItemCallBack: _vm.fetchData },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "searchAreaHeader",
                            fn: function() {
                              return undefined
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3357050351
                      )
                    },
                    [
                      _c(
                        "template",
                        { slot: "operations" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success" },
                              on: {
                                click: function($event) {
                                  return _vm.addInquiry("")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Insurance.AddInquiryQuestionnaire")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.editInquiry }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Insurance.EditOrViewQuestionnaire")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "section grid-wrapper",
                  staticStyle: { "flex-grow": "1" }
                },
                [
                  _vm.insuranceType === 1
                    ? _c("cargo-ag-grid", {
                        attrs: {
                          "config-module": "110101",
                          "grid-params": _vm.gridParams,
                          "grid-options": _vm.gridOptions,
                          "column-defs": _vm.insureColumnDefs,
                          "row-data": _vm.rowData,
                          height: "100%"
                        },
                        on: {
                          "update:gridParams": function($event) {
                            _vm.gridParams = $event
                          },
                          "update:grid-params": function($event) {
                            _vm.gridParams = $event
                          },
                          gridReady: function(params) {
                            return (_vm.gridApi = params.api)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.insuranceType === 2
                    ? _c("cargo-ag-grid", {
                        attrs: {
                          "config-module": "110201",
                          "grid-params": _vm.gridParams,
                          "grid-options": _vm.gridOptions,
                          "column-defs": _vm.inquiryColumnDefs,
                          "row-data": _vm.rowData,
                          height: "100%"
                        },
                        on: {
                          "update:gridParams": function($event) {
                            _vm.gridParams = $event
                          },
                          "update:grid-params": function($event) {
                            _vm.gridParams = $event
                          },
                          gridReady: function(params) {
                            return (_vm.gridApi = params.api)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end"
                      }
                    },
                    [
                      _c("currency-total-group", {
                        attrs: { "data-provider": _vm.premiumList }
                      })
                    ],
                    1
                  ),
                  _vm.insuranceType === 1
                    ? _c("cargo-pagination", {
                        attrs: {
                          "config-module": "110102",
                          total: _vm.searchConditions.total,
                          page: _vm.searchConditions.pageNum,
                          limit: _vm.searchConditions.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(
                              _vm.searchConditions,
                              "pageNum",
                              $event
                            )
                          },
                          "update:limit": function($event) {
                            return _vm.$set(
                              _vm.searchConditions,
                              "pageSize",
                              $event
                            )
                          },
                          pagination: _vm.fetchDataByPage
                        }
                      })
                    : _vm._e(),
                  _vm.insuranceType === 2
                    ? _c("cargo-pagination", {
                        attrs: {
                          "config-module": "110202",
                          total: _vm.searchConditions.total,
                          page: _vm.searchConditions.pageNum,
                          limit: _vm.searchConditions.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(
                              _vm.searchConditions,
                              "pageNum",
                              $event
                            )
                          },
                          "update:limit": function($event) {
                            return _vm.$set(
                              _vm.searchConditions,
                              "pageSize",
                              $event
                            )
                          },
                          pagination: _vm.fetchDataByPage
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.showGrid
        ? _c(
            "div",
            {
              staticClass: "main-content",
              staticStyle: { background: "white", height: "800px" }
            },
            [
              _c("div", { staticStyle: { "text-align": "right" } }, [
                _c("i", {
                  staticClass: "el-icon-close",
                  staticStyle: { "font-size": "20px", margin: "10px" },
                  on: {
                    click: function($event) {
                      return _vm.showGridPage(null)
                    }
                  }
                })
              ]),
              _vm._m(0),
              _c("hr", { staticStyle: { margin: "0 40px" } }),
              _c("h1", { staticStyle: { "text-align": "center" } }, [
                _vm._v("您还可以")
              ]),
              _c("br"),
              _c("h1", { staticStyle: { "text-align": "center" } }, [
                _vm._v(_vm._s("电话联系：" + _vm.getInsureAgentContact()))
              ])
            ]
          )
        : _vm._e(),
      _c("inquiry", {
        ref: "inquiry",
        attrs: { visible: _vm.inquiry.visible },
        on: { close: _vm.closeInquiry, showGridPage: _vm.showGridPage }
      }),
      _c(
        "cargo-dialog",
        {
          attrs: {
            title: _vm.$t("FileHistory.preview"),
            visible: _vm.previewFileData.visible,
            "can-maximize": true,
            "custom-class": "preview-dialog"
          },
          on: { close: _vm.closePreviewDialog }
        },
        [
          _c(
            "div",
            [
              _c("p", { staticStyle: { "text-align": "center" } }, [
                _c(
                  "span",
                  {
                    staticClass: "turn",
                    class: { grey: _vm.previewFileData.currentPage == 1 },
                    on: {
                      click: function($event) {
                        return _vm.changePdfPage(0)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Pre")))]
                ),
                _vm._v(
                  " " +
                    _vm._s(_vm.previewFileData.currentPage) +
                    " / " +
                    _vm._s(_vm.previewFileData.numPages) +
                    " "
                ),
                _c(
                  "span",
                  {
                    staticClass: "turn",
                    class: {
                      grey:
                        _vm.previewFileData.currentPage ==
                        _vm.previewFileData.numPages
                    },
                    on: {
                      click: function($event) {
                        return _vm.changePdfPage(1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Next")))]
                )
              ]),
              _c("pdf", {
                attrs: {
                  src: _vm.previewFileData.pdfSrc,
                  page: _vm.previewFileData.currentPage
                },
                on: {
                  "num-pages": function($event) {
                    _vm.previewFileData.numPages = $event
                  },
                  "page-loaded": function($event) {
                    _vm.previewFileData.currentPage = $event
                  },
                  loaded: _vm.loadPdfHandler
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h1",
      {
        staticStyle: {
          "text-align": "center",
          "margin-top": "10%",
          "margin-bottom": "4%"
        }
      },
      [
        _c("i", {
          staticClass: "el-icon-success",
          staticStyle: {
            color: "#13ce66",
            "font-size": "50px",
            "margin-right": "20px"
          }
        }),
        _vm._v("提交成功，我们会在24小时之内由专人与您取得联系")
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }